<template>
    <div>         
        <div class="aside-widget">
            <header>
                <h3>类别</h3>
            </header>
            <div class="body">
                <ul class="clean-list">
                    <li><a @click="changeCategory(1)">大模型</a></li>
                    <li><a @click="changeCategory(2)">Python</a></li>
                    <li><a @click="changeCategory(6)">Golang</a></li>
                    <li><a @click="changeCategory(3)">中间件</a></li>
                    <li><a @click="changeCategory(4)">其他</a></li>
                </ul>
            </div>
        </div>

        <div class="aside-widget">
            <header>
                <h3>作品</h3>
            </header>
            <div class="body clearfix">
                <ul class="clean-list">
                    <li><a @click="viewProducts('sales')">智能销售</a></li>
                    <li><a @click="viewProducts('analyzer')">客情分析</a></li>
                    <li><a @click="viewProducts('create')">创作空间</a></li>
                    <li><a @click="viewService('crm')">客户管理</a></li>
                    <li><a @click="viewService('edm')">邮件营销</a></li>
                </ul>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
  name: 'navi',
  methods : {
    changeCategory: function (category){
        this.$router.push({
            name: 'Jump',
            query: {
                category: category
            }
        })
    },
    viewProducts: function (product){
        window.open("/"+product, "_blank")
    },
    viewService: function (service){
        window.open("http://"+service+".pythonup.cn", "_blank")
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/navi.vue